<template>
    <b-card
      v-if="array"
      no-body
      class="card-statistics"
    >
      <!-- <b-card-header>
        <b-card-title>Estatisticas</b-card-title>
        <b-card-text class="font-small-2 mr-25 mb-0">
          Resultado 
        </b-card-text>
      </b-card-header> -->
      <b-card-body class="statistics-body">
        <b-row>

            <b-col
            xl="3"
            sm="6"
            :class="saldoEstabelecimento.customClass"
          >
            <b-media no-body>
              <b-media-aside
  
                class="mr-2"
              >
                <b-avatar
                  size="48"
                  :variant="saldoEstabelecimento.color"
                >
                  <feather-icon
                    size="24"
                    :icon="saldoEstabelecimento.icon"
                  />
                </b-avatar>
              </b-media-aside>
              <b-media-body class="my-auto">
                <h4 class="font-weight-bolder mb-0">
                  {{ formatPriceR(saldoEstabelecimento.title) }}
                </h4>
                <b-card-text class="font-small-3 mb-0">
                  {{ saldoEstabelecimento.subtitle }}
                </b-card-text>
              </b-media-body>
            </b-media>
          </b-col>

        


        </b-row>
      </b-card-body>
    </b-card>
  </template>
  
  <script>
  import {
    BCard, BCardHeader, BCardTitle, BCardText, BCardBody, BRow, BCol, BMedia, BMediaAside, BAvatar, BMediaBody,
  } from 'bootstrap-vue'
  
  export default {
    components: {
      BRow,
      BCol,
      BCard,
      BCardHeader,
      BCardTitle,
      BCardText,
      BCardBody,
      BMedia,
      BAvatar,
      BMediaAside,
      BMediaBody,
    },
    props: {
      data: {
        type: Array,
        default: () => [],
      },
    },

    data() {
        return {
            statusTab:true,
            array: [
                    
                    {
                        icon: 'DollarSignIcon',
                        color: 'light-success',
                        title: this.formatPriceR(this.$store.state.estabelecimentos.recebidosHoje),
                        subtitle: 'Recebidos Hoje',
                        customClass: ' mt-2 mb-2 mb-xl-0',
                    },
                    {
                        icon: 'DollarSignIcon',
                        color: 'light-danger',
                        title: 'R$ '+ this.$store.state.estabelecimentos.pagamentosVencer,
                        subtitle: 'Cobranças a Vencer',
                        customClass: ' mt-2 mb-2 mb-xl-0',
                    },
                    // {
                    //   icon: 'TrendingUpIcon',
                    //   color: 'light-danger',
                    //   title: '000',
                    //   subtitle: 'Cobranças a Vencer',
                    //   customClass: ' mt-2 mb-2 mb-xl-0',
                    // },
                    
                    
                ]
        }
    },
    created() {
       
    },
    computed:{
        saldoEstabelecimento(){
                 const a ={
                        icon: 'DollarSignIcon',
                        color: 'light-primary',
                        title: this.$store.state.estabelecimentos.saldoEstabelecimento,
                        subtitle: 'Saldo Total',
                        customClass: ' mt-2 mb-2 mb-xl-0',
                    }
              
            return a
                  
        },
        recebidosMes(){
                    
                 const a=   {
                        icon: 'DollarSignIcon',
                        color: 'light-info',
                        title: 'R$ '+ this.$store.state.estabelecimentos.recebidosMes,
                        subtitle: 'Recebidos Mês',
                        customClass: ' mt-2 mb-2 mb-xl-0',
                    }

                    return a
                }
       
    },
    methods:{
          
      formatPriceR(value) {
        return value.toLocaleString('pt-br', {minimumFractionDigits: 2});
          },
    
    
        }
  }
  </script>
  